import * as React from "react";

import IntegrationCard from "@editor/components/dashboard/integrations/IntegrationCard";
import {
  LoadedSettings,
  SettingsLayout,
} from "@editor/components/shops-ui/settings/SettingsCard";
import { useGetIntegrationsQuery } from "@editor/reducers/sanity-reducer";

const Integrations: React.FC = () => {
  const { data: otherIntegrations } = useGetIntegrationsQuery({});

  const sections = [
    {
      title: "Available Integrations",
      description:
        "Helpful guides to get you up and running with your favorite integrations.",
      component: (
        <div className="mb-4 flex flex-wrap gap-4">
          {otherIntegrations &&
            otherIntegrations.map((integration) => (
              <IntegrationCard
                key={integration.name}
                title={integration.name}
                image={integration.image}
                redirectUrl={integration.documentationUrl}
              />
            ))}
        </div>
      ),
    },
  ];

  return (
    <SettingsLayout maxWidth="max-w-[1000px]">
      <LoadedSettings sections={sections} />
    </SettingsLayout>
  );
};

export default Integrations;
